import { render } from "./Key0.vue?vue&type=template&id=07dc0c99"
import script from "./Key0.vue?vue&type=script&lang=ts"
export * from "./Key0.vue?vue&type=script&lang=ts"
script.render = render

export default script